import React from 'react';
import { Star, ShoppingCart } from 'lucide-react';
import { motion } from 'framer-motion';
export interface BookProps {
  id: string;
  title: string;
  author: string;
  price: number;
  rating: number;
  color: string;
  category?: string;
}
interface BookCardProps {
  book: BookProps;
  delay?: number;
  featured?: boolean;
}
export function BookCard({
  book,
  delay = 0,
  featured = false
}: BookCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay
  }} className={`bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow border border-gray-100 overflow-hidden ${featured ? 'flex flex-col sm:flex-row' : 'flex flex-col'}`} data-id="element-8">
      {/* Book Cover */}
      <div className={`relative shrink-0 flex items-center justify-center p-6 text-center ${book.color} ${featured ? 'sm:w-48 aspect-[2/3]' : 'w-full aspect-[2/3]'}`} style={{
      boxShadow: 'inset -4px 0 15px rgba(0,0,0,0.1), inset 2px 0 4px rgba(255,255,255,0.2)'
    }} data-id="element-9">
        {/* Spine effect */}
        <div className="absolute left-0 top-0 bottom-0 w-2 bg-black/20" data-id="element-10" />
        <div className="absolute left-2 top-0 bottom-0 w-0.5 bg-white/20" data-id="element-11" />

        <div className="z-10" data-id="element-12">
          <p className="text-white/80 text-xs uppercase tracking-[0.2em] mb-3 font-medium" data-id="element-13">
            {book.author}
          </p>
          <h3 className="text-white font-bold text-xl leading-snug" data-id="element-14">
            {book.title}
          </h3>
        </div>
      </div>

      {/* Book Details */}
      <div className={`p-5 flex flex-col flex-grow ${featured ? 'sm:p-8 justify-center' : ''}`} data-id="element-15">
        {book.category && <span className="self-start px-2.5 py-1 bg-indigo-50 text-indigo-700 text-xs font-semibold rounded-full mb-3" data-id="element-16">
            {book.category}
          </span>}

        <h4 className={`font-bold text-slate-900 mb-1 ${featured ? 'text-2xl' : 'text-lg line-clamp-1'}`} data-id="element-17">
          {book.title}
        </h4>

        <p className="text-sm text-slate-500 mb-3" data-id="element-18">{book.author}</p>

        <div className="flex items-center gap-1 mb-5" data-id="element-19">
          {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < Math.floor(book.rating) ? 'fill-amber-400 text-amber-400' : 'fill-gray-200 text-gray-200'}`} data-id="element-20" />)}
          <span className="text-xs font-medium text-slate-600 ml-1.5" data-id="element-21">
            {book.rating}
          </span>
        </div>

        <div className="mt-auto flex items-center justify-between pt-4 border-t border-gray-100" data-id="element-22">
          <span className={`font-bold text-slate-900 ${featured ? 'text-2xl' : 'text-xl'}`} data-id="element-23">
            ${book.price.toFixed(2)}
          </span>
          <button className="flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-indigo-700 transition-colors shadow-sm" aria-label="Comprar" data-id="element-24">
            Comprar
            <ShoppingCart className="w-4 h-4" data-id="element-25" />
          </button>
        </div>
      </div>
    </motion.div>;
}